import axios from 'axios';
import firebase from 'firebase/compat/app';
import { API_URL } from '../environment';

const getToken = () => firebase.auth().currentUser?.getIdToken();

export const importProducts = async (
  companyId: string,
  file: File,
  csvHeaders: string,
  dryRun = true,
  showInShop = false,
  separator = ',',
  encoding = 'latin1',
) => {
  const token = await getToken();
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const formData = new FormData();
  formData.append('file', file);
  formData.append('header', csvHeaders);
  formData.append('dryRun', dryRun.toString());
  formData.append('showInShop', showInShop.toString());
  formData.append('separator', separator);
  formData.append('encoding', encoding);

  return axios({
    url: `${API_URL}/v1/company/${companyId}/products/importCsv`,
    method: 'POST',
    headers,
    data: formData,
  }).then((response) => response.data);
};

export const getImportJobStatus = async (companyId: string, importJobId: string) => {
  const token = await getToken();
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  return axios({
    url: `${API_URL}/v1/company/${companyId}/importJobs/${importJobId}`,
    method: 'GET',
    headers,
  }).then((response) => response.data);
};

export const getImportJobsList = async (companyId: string) => {
  const token = await getToken();
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  return axios({
    url: `${API_URL}/v1/company/${companyId}/importJobs`,
    method: 'GET',
    headers,
  }).then((response) => response.data);
};
